import { ViewModel } from "./ViewModel";
import { userInfo } from "../../repositories/companyRepository";

export default function getViewModelNewValues(): ViewModel {
  let r: ViewModel = {
    customerRepName: "",
    customerRepEMail: userInfo.eMail,
    customerRepPhone: userInfo.phoneNumber,
    salesDocument: null,
    complaintItems: [],
    attachments: [],
    };
    
  return r;
}
